import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import { useNavigate } from 'react-router-dom';
import '../../components/loader.css';

const Auto_post_delivery = () => {
    const [selectedFileType, setSelectedFileType] = useState('');
    const [file, setFile] = useState(null);
    const [fileRecords, setFileRecords] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
    });

    const fileTypes = [
        { value: 'MIS', label: 'MIS Report' },
        { value: 'INVOICE_ANNEXURE', label: 'Invoice Annexure' },
        { value: 'CWD', label: 'CWD Report' }
    ];

    // Fetch file records on component mount
    useEffect(() => {
        fetchFileRecords();
    }, []);

    const fetchFileRecords = async () => {
        try {
            const response = await axios.get(
                `${exportValue.host}/${exportValue.version}/${exportValue.api}/vas_charge_files`,
                { headers: exportValue.headers }
            );
            setFileRecords(response.data);
        } catch (error) {
            console.error('Error fetching file records:', error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to load file records'
            });
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file || !selectedFileType) return;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileType', selectedFileType);

        try {
            const endpoint = `${exportValue.host}/${exportValue.version}/${exportValue.api}/upload_post_pricing_files`;
            const response = await axios.post(endpoint, formData, {
                headers: exportValue.headers
            });

            if (response.status === 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'File uploaded successfully! Processing started.'
                });

                // Refresh the page to show new record
                window.location.reload();
            }
            else {
                Toast.fire({
                    icon: 'error',
                    title: response.error
                })
            }

        } catch (error) {
            console.error('Upload failed', error);
            let errorMessage = 'File upload failed';

            if (error.response) {
                errorMessage = error.response.data.error ||
                    error.response.data.message ||
                    `Server responded with ${error.response.status}`;
            } else if (error.request) {
                errorMessage = 'No response received from server';
            }

            Toast.fire({
                icon: 'error',
                title: errorMessage
            });
        }
    };

    const viewLogs = (fileId) => {
        navigate(`/vas_charges_logs/${fileId}`);
    };

    return (
        <div>
            <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

            <section className="home-section">
                <Sub_header />

                <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
                    <h2 style={{ marginBottom: '20px', color: '#333' }}>VAS Charges File Upload</h2>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '20px',
                        marginBottom: '30px'
                    }}>
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                    Select File Type:
                                </label>
                                <select
                                    value={selectedFileType}
                                    onChange={(e) => setSelectedFileType(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd'
                                    }}
                                >
                                    <option value="">Select file type</option>
                                    {fileTypes.map(type => (
                                        <option key={type.value} value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                    Select File:
                                </label>
                                <input
                                    type="file"
                                    onChange={handleFileChange}
                                    accept=".csv"
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd'
                                    }}
                                />
                            </div>

                            <button
                                onClick={handleUpload}
                                disabled={!file || !selectedFileType}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    padding: '10px 15px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    opacity: (!file || !selectedFileType) ? 0.5 : 1
                                }}
                            >
                                Upload and Process
                            </button>
                        </div>

                        {file && (
                            <div style={{
                                border: '1px solid #ddd',
                                padding: '15px',
                                borderRadius: '4px'
                            }}>
                                <h3 style={{ marginBottom: '10px' }}>Selected File</h3>
                                <p><strong>Name:</strong> {file.name}</p>
                                <p><strong>Type:</strong> {selectedFileType}</p>
                                <p><strong>Size:</strong> {(file.size / 1024).toFixed(2)} KB</p>
                            </div>
                        )}
                    </div>

                    {fileRecords.length > 0 && (
                        <div>
                            <h3 style={{ marginBottom: '15px' }}>Uploaded Files</h3>
                            <div style={{
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                overflow: 'hidden'
                            }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>File Name</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Type</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Total Records</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Processed</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Status</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fileRecords.map((record, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '10px' }}>{record.originalName}</td>
                                                <td style={{ padding: '10px' }}>{record.fileType}</td>
                                                <td style={{ padding: '10px' }}>{record.totalRecords}</td>
                                                <td style={{ padding: '10px' }}>{record.processedRecords}</td>
                                                <td style={{ padding: '10px' }}>
                                                    <span style={{
                                                        color: record.status === 'COMPLETED' ? 'green' :
                                                            record.status === 'FAILED' ? 'red' : 'orange',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {record.status}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '10px' }}>
                                                    <button
                                                        onClick={() => viewLogs(record._id)}
                                                        style={{
                                                            backgroundColor: '#2196F3',
                                                            color: 'white',
                                                            padding: '5px 10px',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        View Logs
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    )
}

export default Auto_post_delivery;